import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { UpsertShoppingListRequest, UpsertShoppingListResponse } from 'src/types/favorite';
import axiosInstance from 'src/utils/axios';

async function upsertShoppingList(
  request: UpsertShoppingListRequest
): Promise<UpsertShoppingListResponse> {
  const res = await axiosInstance.post<UpsertShoppingListResponse>(
    api.upsertShoppingList,
    request
  );
  return res.data;
}

interface UseUpsertShoppingListMutationOptions {
  onSuccess?: (data: UpsertShoppingListResponse, variables: UpsertShoppingListRequest) => void;
  onError?: (error: unknown) => void;
}

const useUpsertShoppingListMutation = ({
  onSuccess,
  onError,
}: UseUpsertShoppingListMutationOptions = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: upsertShoppingList,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.favorite.allFolders() });
      queryClient.invalidateQueries({ queryKey: queryKeys.favorite.folders() });
      onSuccess?.(data, variables);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export default useUpsertShoppingListMutation;
